import React, { ReactNode, useEffect, useMemo, useRef } from 'react';
import { InnoIcon, InnoPopover } from '@innomotics/innomotics-build-react-lib';

export interface MultilineTooltipProps {
    idName: string;
    text: string;
    icon?: string;
    size?: string;
    placement?: string;
    children?: ReactNode;
    html?: boolean;
    closable?: boolean;
}

const MultilineTooltip = ({ text, html, icon = 'information', size = '24', placement = 'bottom', idName, closable = true }: MultilineTooltipProps) => {
    const forId = useMemo(() => `#${idName}`, [idName]);

    const iconRef = useRef<any>(null);
    const popoverRef = useRef<any>(null);

    useEffect(() => {
        const onDocPointerDown = (e: PointerEvent) => {
            const pop = popoverRef.current;
            if (!pop?.visible) return;

            const path = (e).composedPath?.() as EventTarget[] | undefined;
            const target = e.target as Node | null;

            const clickedInsidePopover =
                (path && path.includes(pop)) ||
                (!!target && typeof pop?.contains === 'function' && pop.contains(target));

            const iconEl = iconRef.current;
            const clickedOnTrigger =
                (path && iconEl && path.includes(iconEl)) ||
                (!!target && iconEl && typeof iconEl.contains === 'function' && iconEl.contains(target));

            if (!clickedInsidePopover && !clickedOnTrigger) {
                pop.visible = false;
            }
        };

        document.addEventListener('pointerdown', onDocPointerDown, true);
        return () => document.removeEventListener('pointerdown', onDocPointerDown, true);
    }, []);

    return (
        <div className='multiline-tooltip-container'>
            <InnoIcon ref={iconRef} id={idName} icon={icon} size={size} />

            <InnoPopover
                ref={popoverRef}
                for={forId}
                placement={placement}
                closable={closable}
            >
                <div className='tooltip-dropdown-container'>
                    {html ? <div dangerouslySetInnerHTML={{ __html: text }} /> : text}
                </div>
            </InnoPopover>
        </div>
    );
};

export default MultilineTooltip;
